export default __webpack_public_path__ + "static/media/illustration-final.049ac145.jpg";